import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="product-filter"
export default class extends Controller {
  static targets = ["search", "product", "container", "noResults", "filterButton"]
  static values = { activeType: { type: String, default: "all" } }

  connect() {
    this.updateButtonStates()
  }

  filter() {
    this.applyFilters()
  }

  filterByType(event) {
    event.preventDefault()
    this.activeTypeValue = event.currentTarget.dataset.productType
    this.applyFilters()
    this.updateButtonStates()
  }

  applyFilters() {
    const searchTerm = this.searchTarget.value.toLowerCase().trim()
    const typeFilter = this.activeTypeValue
    let visibleCount = 0

    this.productTargets.forEach(product => {
      const productName = product.dataset.productName
      const productType = product.dataset.productType

      const matchesSearch = productName.includes(searchTerm)
      const matchesType = typeFilter === "all" || productType === typeFilter

      if (matchesSearch && matchesType) {
        product.classList.remove("hidden")
        visibleCount++
      } else {
        product.classList.add("hidden")
      }
    })

    // Show/hide no results message
    if (this.hasNoResultsTarget) {
      if (visibleCount === 0) {
        this.noResultsTarget.classList.remove("hidden")
        this.containerTarget.classList.add("hidden")
      } else {
        this.noResultsTarget.classList.add("hidden")
        this.containerTarget.classList.remove("hidden")
      }
    }
  }

  updateButtonStates() {
    this.filterButtonTargets.forEach(button => {
      const isActive = button.dataset.productType === this.activeTypeValue

      if (isActive) {
        button.classList.remove("bg-white", "text-gray-700", "hover:bg-gray-50")
        button.classList.add("bg-green-700", "text-white")
      } else {
        button.classList.remove("bg-green-700", "text-white")
        button.classList.add("bg-white", "text-gray-700", "hover:bg-gray-50")
      }
    })
  }
}
